import { render, staticRenderFns } from "./BancosLista.vue?vue&type=template&id=74796908&scoped=true&"
import script from "./BancosLista.vue?vue&type=script&setup=true&lang=js&"
export * from "./BancosLista.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74796908",
  null
  
)

export default component.exports